export const currencies = [
  {
    code: 'USD',
    name: 'United States Dollar',
    symbol: '$',
    flag: '🇺🇸',
  },
  {
    code: 'AUD',
    name: 'Australian Dollar',
    symbol: '$',
    flag: '🇦🇺',
  },
  {
    code: 'GBP',
    name: 'British Pound',
    symbol: '£',
    flag: '🇬🇧',
  },
  {
    code: 'EUR',
    name: 'Euro',
    symbol: '€',
    flag: '🇪🇺',
  },
  {
    code: 'CNY',
    name: 'Chinese Yuan',
    symbol: '¥',
    flag: '🇨🇳',
  },
  {
    code: 'HKD',
    name: 'Hong Kong Dollar',
    symbol: 'HK$',
    flag: '🇭🇰',
  },
  {
    code: 'SGD',
    name: 'Singapore Dollar',
    symbol: 'S$',
    flag: '🇸🇬',
  },
  {
    code: 'NZD',
    name: 'New Zealand Dollar',
    symbol: 'NZ$',
    flag: '🇳🇿',
  },
  {
    code: 'JPY',
    name: 'Japanese Yen',
    symbol: '¥',
    flag: '🇯🇵',
  },
  {
    code: 'CAD',
    name: 'Canadian Dollar',
    symbol: 'CA$',
    flag: '🇨🇦',
  },
  {
    code: 'CHF',
    name: 'Swiss Franc',
    symbol: 'CHF',
    flag: '🇨🇭',
  },
  {
    code: 'BRL',
    name: 'Brazilian Real',
    symbol: 'R$',
    flag: '🇧🇷',
  },
]

/**
 * Format a currency amount to a string
 * @param amount In dollars, not cents
 * @param currency The currency code
 * @returns Formatted currency string
 */
export const formatCurrency = (amount: number, currency?: string) => {
  return (
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency || 'USD',
    }).format(amount || 0) +
    ' ' +
    (currency || 'USD')
  )
}

export const formatThousandsOnly = (value: string): string => {
  if (!value) {
    return ''
  }

  // Remove commas before parsing to handle values like "1,000"
  const cleanedValue = value.replace(/,/g, '')
  const num = parseFloat(cleanedValue)
  if (isNaN(num)) {
    return ''
  }

  // Use Math.floor to truncate decimals and convert to integer
  return Math.floor(num).toLocaleString('en-US')
}
